import TeacherAccountDetails from './TeacherAccountDetails.page';

export default TeacherAccountDetails;